



























































































































































































































import Reflect from "reflect-metadata";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { User } from "@/models/User";
import { Contact } from "@/models/Contact";
import { Budget } from "@/models/Budget";
import { Plant } from "@/models/Plant";
import { Client } from "@/models/Client";
import contactService, { ContactFilters } from "@/services/ContactService";
import budgetService from "@/services/BudgetService";
import clientService from "@/services/ClientService";
import { PermissionsPayload } from "@/services/UserService";
import { Project } from "@/models/Project";

@Component
export default class UserPermission extends Vue {
  @Prop()
  sessionUser!: User;
  @Prop()
  user!: Partial<User>;
  @Prop()
  permissions!: PermissionsPayload[];

  contacts: Contact[] | undefined = [];
  budgets: Budget[] | undefined = [];
  plants: Plant[] | undefined = [];
  projects: Project[] | undefined = [];
  selectedBudgets: Budget[] = [];
  selectedPlants: Plant[] = [];
  selectedProjects: Project[] = [];

  loading = false;
  budgetLoading = false;
  plantsLoading = false;
  projectsLoading = false;
  filters: ContactFilters = {};

  /**
   * Validation rules for inputs
   */
  rules = {
    required: (value: string) => !!value || "El campo es requerido",
    max: (value: string) =>
      (value && value.length <= 50) || "Máximo 50 caracteres",
    min: (value: string) =>
      (value && value.length >= 8) || "Mínimo 8 caracteres",
  };
  /**
   * Sets selected budget permissions from user.
   */
  setBudgetPermissions() {
    if (this.permissions && this.budgets) {
      let perms = this.permissions.map((perm) => {
        return perm.budget_id;
      });
      this.selectedBudgets = this.budgets.filter((budget) => {
        return perms.includes(budget.id);
      });
    }
  }
  /**
   * Sets selected plant permissions from user.
   */
  setPlantPermissions() {
    if (this.permissions && this.plants) {
      let perms = this.permissions.map((perm) => {
        return perm.plant_id;
      });
      this.selectedPlants = this.plants.filter((plant) => {
        return perms.includes(plant.id);
      });
    }
  }

  /**
   * Sets selected project permissions from user.
   */
  setProjectPermissions() {
    if (this.permissions && this.projects) {
      let perms = this.permissions.map((perm) => {
        return perm.project_id;
      });
      this.selectedProjects = this.projects.filter((project) => {
        return perms.includes(project.id);
      });
    }
  }

  /**
   * Fetches available contacts filtered by user input with debounce
   */
  loadContacts() {
    this.loading = true;
    contactService
      .get(this.filters)
      .then((response) => {
        this.contacts = response.data as Contact[];
      })
      .finally(() => {
        this.loading = false;
      });
  }
  /**
   * Executes on mount. Fetches budget and plants data.
   */
  mounted() {
    // If session user is superadmin, load all contacts
    if (this.sessionUser && this.sessionUser.is_superadmin) {
      this.loadContacts();
    } else {
      // If session user is not superadmin, set the session user
      // contact as the only available contact for editing.
      if (this.sessionUser && this.sessionUser.contact) {
        this.contacts = [this.sessionUser.contact];
      }
    }
    // If the user is being edited and already has a contact,
    // load contact data.
    if (this.user && this.user.contact) {
      this.onContactChanged(
        this.user.contact,
        this.setBudgetPermissions,
        this.setPlantPermissions,
        this.setProjectPermissions
      );
    }
  }

  /**
   * Custom filter for the contact select object. Allows both
   * contact and client name matches with the query string.
   */
  contactFilter = (
    item: Contact,
    queryText: string,
    itemText: string
  ): boolean => {
    let query = queryText.toLowerCase();
    return (
      item.name.toLowerCase().includes(query) ||
      item.email.toLowerCase().includes(query) ||
      (!!item.client &&
        !!item.client.name &&
        item.client.name.toLowerCase().includes(query))
    );
  };

  /**
   * Emits a change event with selected budget, plants and projects as permissions for the new user
   */
  onPermissionChange() {
    this.$root.$emit("change:permissions", {
      selectedBudgets: this.selectedBudgets.map((item) => {
        return {
          budget_id: item.id,
        };
      }),
      selectedPlants: this.selectedPlants.map((item) => {
        return {
          plant_id: item.id,
        };
      }),
      selectedProjects: this.selectedProjects.map((item) => {
        return {
          project_id: item.id,
        };
      }),
    });
  }

  /**
   * Called when admin checkbox is clicked. Emits an user change event.
   */
  handleAdminChange(value?: boolean) {
    this.selectedBudgets = [];
    this.selectedPlants = [];
    this.selectedProjects = [];
    this.onPermissionChange();
  }
  /**
   * Called when superadmin checkbox is clicked. Emits an user change event.
   */
  handleSuperadminChange(value?: boolean) {
    this.$root.$emit("change:user", { is_admin: false, contact: undefined });
    this.handleAdminChange();
  }

  /**
   * Executes when the user's contact is changed. Gets both budgets and
   * plants associated to the contact.
   */
  onContactChanged(
    val: Contact | undefined,
    cb1?: () => void,
    cb2?: () => void,
    cb3?: () => void
  ) {
    this.plants = [];
    this.budgets = [];
    if (!cb1 && !cb2) this.handleAdminChange();
    if (val && val.id) {
      this.budgetLoading = true;
      this.plantsLoading = true;
      this.projectsLoading = true;
      /* Fetch budgets */
      budgetService
        .get({ contact: val.id })
        .then((response) => {
          this.budgets = response.data as Budget[];
          if (cb1) cb1();
        })
        .finally(() => {
          this.budgetLoading = false;
        });
      /* Fetch client's plants */
      clientService
        .get({ id: val.client.id })
        .then((response) => {
          this.plants = (response.data as Client).plants;
          if (cb2) cb2();
          this.projects = (response.data as Client).projects;
          if (cb3) cb3();
        })
        .finally(() => {
          this.plantsLoading = false;
          this.projectsLoading = false;
        });
    }
  }

  /**
   * Removes a budget from the selected list
   */
  removeBudget(id: number) {
    let index = this.selectedBudgets.findIndex((item) => {
      return item.id == id;
    });
    if (index >= 0) {
      this.selectedBudgets.splice(index, 1);
      this.selectedBudgets = [...this.selectedBudgets];
    }
    this.onPermissionChange();
  }
  /**
   * Removes a plant from the selected list
   */
  removePlant(id: number) {
    let index = this.selectedPlants.findIndex((item) => {
      return item.id == id;
    });
    if (index >= 0) {
      this.selectedPlants.splice(index, 1);
      this.selectedPlants = [...this.selectedPlants];
    }
    this.onPermissionChange();
  }
  /**
   * Removes a project from the selected list
   */
  removeProject(id: number) {
    let index = this.selectedProjects.findIndex((item) => {
      return item.id == id;
    });
    if (index >= 0) {
      this.selectedProjects.splice(index, 1);
      this.selectedProjects = [...this.selectedProjects];
    }
    this.onPermissionChange();
  }
}
